export const SET_TIPO_ACTION = 'tipo';
export const SET_LEVEL_ACTION = 'level';
export const SET_DATA_INICIAL_ACTION = 'dataInicial';
export const SET_DATA_FINAL_ACTION = 'dataFinal';
